import React, { useEffect, useState } from "react";
import { api, BRAND, formatApiError } from "@/lib/api";
import { PageHeader, EmptyState } from "@/components/Common";
import { Megaphone } from "lucide-react";
import { toast } from "sonner";

export default function StudentAnnouncements() {
  const [items, setItems] = useState([]);
  useEffect(() => {
    api.get("/announcements").then(r => setItems(r.data))
      .catch(err => toast.error(formatApiError(err)));
  }, []);

  return (
    <div data-testid="student-announcements-page">
      <PageHeader eyebrow="Mural" title="Avisos" mascot={BRAND.MANGUITA_FORCA} />
      {items.length === 0 ? (
        <EmptyState title="Nenhum aviso" description="Quando o administrador publicar novidades, elas aparecerão aqui." mascot={BRAND.MANGUITA} />
      ) : (
        <div className="space-y-3">
          {items.map(a => (
            <div key={a.id} className="vv-card p-5">
              <div className="flex items-start gap-3">
                <div className="size-10 rounded-lg bg-primary/15 flex items-center justify-center">
                  <Megaphone className="size-5 text-[hsl(var(--vv-yellow))]" />
                </div>
                <div>
                  <div className="font-black text-lg">{a.title}</div>
                  <div className="text-xs text-muted-foreground mt-0.5">{new Date(a.created_at).toLocaleString("pt-BR")}</div>
                  <p className="mt-2 text-sm whitespace-pre-wrap">{a.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
